<template>
    <ul class="nav nav-tabs border-primary" id="custom-tabs-four-tab" role="tablist">
        <template v-if="user_type == '0'">
            <li  class="nav-item border-left border-right">
                <a class="nav-link" :class="{'active': user_type=='0'}" id="student-detail-tab" data-toggle="pill" href="#student_detail_tab" role="tab" aria-controls="student_detail_tab" aria-selected="false">
                    <strong>Student Basic details</strong>
                </a>
            </li>
            <li  class="nav-item border-left border-right">
                <a class="nav-link "  id="programmes-tab" data-toggle="pill" href="#programmes" role="tab" aria-controls="programmes" aria-selected="false">
                    <strong>Apply Now</strong>
                </a>
            </li>
            <li class="nav-item border-left border-right">
                <a class="nav-link " id="gov_sholarship_detail_tab" data-toggle="pill" href="#gov_sholarship_detail" role="tab" aria-controls="gov_sholarship_detail_tab" aria-selected="false">
                    <strong>Application Details</strong>
                </a>
            </li>
        </template>
        <li v-if="user_type == '1'" class="nav-item border-left border-right">
            <a class="nav-link " :class="{'active': user_type =='1'}" id="gov-sholarship" data-toggle="pill" href="#gov-sholarship" role="tab" aria-controls="gov-sholarship" aria-selected="false">
                 <strong>Application Details</strong>
            </a>
        </li>
        <template v-else-if="user_type == '4'">
            <li  class="nav-item border-left border-right">
                <a class="nav-link" :class="{'active': user_type=='4'}" id="admit-students-tab" data-toggle="pill" href="#admit_students_tab" role="tab" aria-controls="admit_students_tab" aria-selected="false">
                    <strong>Admit Students to School</strong>
                </a>
            </li>
            <li  class="nav-item border-left border-right">
                <a class="nav-link" id="admission-detail-school-tab" data-toggle="pill" href="#admission_detail_school_tab" role="tab" aria-controls="admission_detail_school_tab" aria-selected="false">
                    <strong>Admission Details</strong>
                </a>
            </li>
        </template>
        <template v-else-if="user_type == '2'">
            <li  class="nav-item border-left border-right">
                <a class="nav-link" :class="{'active': user_type=='2'}" id="admit-students-by-deo" data-toggle="pill" href="#admit_students_by_deo" role="tab" aria-controls="admit-students-by-deo" aria-selected="false">
                    <strong>Admit Students to School</strong>
                </a>
            </li>
            <li  class="nav-item border-left border-right">
                <a class="nav-link" id="admission-detail-deo-tab" data-toggle="pill" href="#admission_detail_deo_tab" role="tab" aria-controls="admission_detail_deo_tab" aria-selected="false">
                    <strong>Admission Details</strong>
                </a>
            </li>
        </template>
        
        <template v-else-if="user_type=='3'">
            <li class="nav-item border-left border-right">
                <a class="nav-link " :class="{'active': user_type=='3'}" id="gov_sholarship_detail_tab" data-toggle="pill" href="#admission-detail-tab" role="tab" aria-controls="admission-detail-tab" aria-selected="false">
                    <strong>Admission Details</strong>
                </a>
            </li>
            <li  class="nav-item border-left border-right">
                <a class="nav-link" :class="{'active': user_type=='2'}" id="admit-students-by-deo" data-toggle="pill" href="#admit_students_by_deo" role="tab" aria-controls="admit-students-by-deo" aria-selected="false">
                    <strong>Admit Students to School</strong>
                </a>
            </li>
        </template>
    </ul>
</template>
<script>
export default {
    data(){
        return {
            user_type:'',
        }
    },
    mounted(){
         axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
        })
        .catch(errors => {
            console.log(errors)
        });
    }
    
}
</script>